// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import {
  Plugin
} from "chart.js";

type ActivePoint = {
  datasetIndex: number;
  index: number;
};

const ChartKeyboardNavPlugin: Plugin<"line"> = {
  id: "keyboardNavigation",

  afterInit(chart) {
    const active: ActivePoint = { datasetIndex: 0, index: 0 };

    const moveHighlight = (delta: number) => {
      const dataset = chart.data.datasets[active.datasetIndex];
      if (!dataset || !dataset.data) return;

      const maxIndex = dataset.data.length - 1;
      active.index = Math.max(0, Math.min(maxIndex, active.index + delta));

      const meta = chart.getDatasetMeta(active.datasetIndex);
      const element = meta.data[active.index];

      if (element) {
        chart.setActiveElements([{ datasetIndex: active.datasetIndex, index: active.index }]);
        chart.tooltip?.setActiveElements(
          [{ datasetIndex: active.datasetIndex, index: active.index }],
          { x: 0, y: 0 }
        );
        chart.update();
      }
    };

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowRight") {
        moveHighlight(1);
      } else if (e.key === "ArrowLeft") {
        moveHighlight(-1);
      }
    };

    // Attach once per chart instance
    chart.canvas.addEventListener("keydown", onKeyDown);
    chart.canvas.setAttribute("tabindex", "0"); // make focusable
  }
};

export default ChartKeyboardNavPlugin;
